import React from 'react';
import { Form } from 'antd';
// Ui
import UploadFilesInput from 'ui/UploadFIlesInput/UploadFilesInput';
// Utils
import {
  CONTRACT_ACCEPT_FILE_TYPES,
  normFile,
} from 'helpers/customCampaignConstants';
// Style
import styles from './TermsSection.module.scss';

const TermsSection = (): JSX.Element => {
  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>Terms</h3>
      <Form.Item getValueFromEvent={normFile} shouldUpdate>
        {(formInstance) => (
          <UploadFilesInput
            title="Additional Contracts"
            value={formInstance.getFieldValue('contracts') || []}
            onChange={(newValue) =>
              formInstance.setFieldsValue({ contracts: newValue })
            }
            acceptFileTypes={CONTRACT_ACCEPT_FILE_TYPES}
          />
        )}
      </Form.Item>
    </section>
  );
};

export default TermsSection;
